// @flow
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';

const TYPESENSE_CONFIG = {
  host: process.env.REACT_APP_TYPESENSE_HOST || '',
  apiKey: process.env.REACT_APP_TYPESENSE_API_KEY || '',
  index: process.env.REACT_APP_TYPESENSE_PRODUCT_INDEX || '',
};

const typesenseAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: TYPESENSE_CONFIG.apiKey,
    nodes: [
      {
        host: TYPESENSE_CONFIG.host,
        port: '443',
        protocol: 'https',
      },
    ],
  },
  additionalSearchParameters: {
    query_by: 'name,description,manufacturer,meta_tags',
    sort_by: 'in_stock_rank:desc,_text_match:desc',
    prioritize_exact_match: true,
    num_typos: 1,
  },
});

export const searchClient = typesenseAdapter.searchClient;
